<template>
  <div class="hiq-detail-planning-list">
    <h1 v-if="searchedQuery && searchedQuery !== '*'">
      {{ translations.searchResultFor }} "{{ searchedQuery }}"
    </h1>
    <div v-else>
      <h1 class="hiq-detail-planning-list__title">{{ title }}</h1>
      <p class="hiq-detail-planning-list__preamble">{{ preamble }}</p>
    </div>
    <div class="hiq-detail-planning-list__search-wrapper">
      <TemplateFilter />
    </div>
    <SelectedFilters />
    <HitCount />
    <HitList />
    <ShowMore />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import HitList from "./components/HitList.vue";
import TemplateFilter from "./components/TemplateFilter.vue";
import ShowMore from "./components/ShowMore.vue";
import HitCount from "./components/HitCount.vue";
import SelectedFilters from "./components/SelectedFilters.vue";
import { ITranslations } from "./store/state";

// Interfaces for component typechecking!
interface AppData {}

interface AppMethods {}

interface AppComputed {
  showMore: boolean;
  searchedQuery: string;
  translations: ITranslations;
  title: string;
  preamble: string;
}

interface AppProps {}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
  name: "app",
  computed: {
    showMore() {
      return this.$store.getters.showMore;
    },
    searchedQuery() {
      return this.$store.getters.searchedQuery;
    },
    translations() {
      return this.$store.getters.translations;
    },
    title() {
      return this.$store.getters.title;
    },
    preamble() {
      return this.$store.getters.preamble;
    },
  },
  components: {
    HitList,
    TemplateFilter,
    ShowMore,
    HitCount,
    SelectedFilters,
  },
});
</script>
